import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from '@shop-builder/core/widget';
import { Configurator } from '@api/services/configurator';
var KissDeviceDetailTabsWidget = /*@__PURE__*/ (function () {
    function KissDeviceDetailTabsWidget() {
    }
    KissDeviceDetailTabsWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadProduct();
                return [2 /*return*/];
            });
        });
    };
    KissDeviceDetailTabsWidget.prototype.loadProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Configurator.getProduct()];
                    case 1:
                        product = _a.sent();
                        this.product = product;
                        Configurator.subscribe('offerChanged', function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                var product;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, Configurator.getProduct()];
                                        case 1:
                                            product = _a.sent();
                                            if (product) {
                                                this.product = product;
                                                this.populateDataTable();
                                                this.populateProductContents();
                                                this.populateTopFeatures();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailTabsWidget.prototype.populateDataTable = function () {
        var groupIds = {
            alltopfeatures: 2,
            display: 6,
            camera: 5,
            memory: 15,
            connectivity: 8,
            simcard: 25,
            handling: 3,
            specials: 4
        };
        var fixvalues = [
            {
                id: 13,
                key: '(PRODUCT) RED',
                value: 'Rot'
            }
        ];
        var child = this.product.getCurrentVersion();
        if (child !== null) {
            this.product = child;
        }
        var tableTemplate = "\n            <table class=\"responsive-table responsive-table-width-full responsive-table-cols-three \">\n                <colgroup>\n                    <col>\n                    <col>\n                    <col>\n                </colgroup>\n                <thead>\n                    <th colspan=\"3\">\n                        Alle Top-Eigenschaften\n                    </th>\n                </thead>\n                <tbody>\n                    {alltopfeatures}\n                    {display}\n                    {camera}\n                    {memory}\n                    {connectivity}\n                    {simcard}\n                    {handling}\n                    {specials}\n                </tbody>\n            </table>\n        ";
        var table = tableTemplate;
        var alltopfeatures = this.getDetailData(groupIds.alltopfeatures, false, false);
        var display = this.getDetailData(groupIds.display, 'Display(s)', false);
        var camera = this.getDetailData(groupIds.camera, 'Digitalkamera', false);
        var memory = this.getDetailData(groupIds.memory, 'Speicher-Eigenschaften', false);
        var connectivity = this.getDetailData(groupIds.connectivity, 'Konnektivit&auml;t', false);
        var simcard = this.getDetailData(groupIds.simcard, 'SIM-Karte', false);
        var handling = this.getDetailData(groupIds.handling, 'Bedienung', false);
        var specials = this.getDetailData(groupIds.specials, 'Specials', false);
        table = table.replace('{alltopfeatures}', alltopfeatures);
        table = table.replace('{display}', display);
        table = table.replace('{camera}', camera);
        table = table.replace('{memory}', memory);
        table = table.replace('{connectivity}', connectivity);
        table = table.replace('{simcard}', simcard);
        table = table.replace('{handling}', handling);
        table = table.replace('{specials}', specials);
        jQuery('[data-techDataTable]').empty().append(table);
    };
    KissDeviceDetailTabsWidget.prototype.getDetailData = function (gId, thead, forcecheck) {
        if (forcecheck === null) {
            forcecheck = false;
        }
        if (thead === null) {
            thead = false;
        }
        var theadTemplate = "\n            <thead>\n                <tr>\n                    <th colspan=\"3\">{GROUPNAME}</th>\n                </tr>\n            </thead>\n        ";
        var subheadTemplate = "\n            <tr class=\"not_grouped subheadline\">\n                <td colspan=\"3\">{GROUPNAME}</td>\n            </tr>\n        ";
        var rowTemplate = "\n            <tr class=\"not_grouped\">\n                <td>{LABEL}</td>\n                <td>{VALUE} {UNIT}</td>\n                <td>{DESC}</td>\n            </tr>\n        ";
        var templateTrue = "\n            <svg class=\"i-xsml i-green\">\n                <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/simplicity/svgdefs.svg#i-list-tick-sml\"></use>\n            </svg>\n        ";
        var templateFalse = "\n            <svg class=\"i-xsml i-red\">\n                <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/simplicity/svgdefs.svg#i-dialog-close-sml\"></use>\n            </svg>\n        ";
        var features = JSON.parse(JSON.stringify(this.GetAttributesByGroup(gId)));
        var featuresMapped = [];
        var _loop_1 = function (featureItem) {
            var temp = featuresMapped.find(function (x) {
                if (x && x.id === featureItem.id) {
                    x.value += ", " + featureItem.value;
                    x.sortOrder = x.description.sortOrder;
                    return true;
                }
            });
            if (!temp)
                featuresMapped.push(featureItem);
        };
        for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
            var featureItem = features_1[_i];
            _loop_1(featureItem);
        }
        featuresMapped.sort(this.sortBySortOrder);
        var featuresHtml = '';
        if (thead) {
            var featureHead = subheadTemplate;
            featureHead = featureHead.replace('{GROUPNAME}', thead);
            featuresHtml += featureHead;
        }
        for (var _a = 0, featuresMapped_1 = featuresMapped; _a < featuresMapped_1.length; _a++) {
            var feature = featuresMapped_1[_a];
            var element = rowTemplate;
            element = element.replace('{LABEL}', feature.description.label);
            var value = feature.value;
            if (feature.description.mask === 'Boolean') {
                value = (value === '1') ? templateTrue : templateFalse;
            }
            element = element.replace('{VALUE}', value);
            var unit = "";
            if (feature.description.unit) {
                unit = feature.description.unit;
            }
            element = element.replace('{UNIT}', unit);
            var description = '';
            if (typeof (feature.description.description) !== 'undefined') {
                description = feature.description.description;
            }
            element = element.replace('{DESC}', description);
            featuresHtml += element;
        }
        return featuresHtml;
    };
    KissDeviceDetailTabsWidget.prototype.GetAttributesByGroup = function (gId) {
        var result = [];
        for (var _i = 0, _a = this.product.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.description.groupId === gId) {
                result.push(attribute);
            }
        }
        result = result.sort(this.sortBySortOrder);
        return result;
    };
    KissDeviceDetailTabsWidget.prototype.GetAttributesById = function (id) {
        var result = [];
        for (var _i = 0, _a = this.product.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === id) {
                result.push(attribute);
            }
        }
        result = result.sort(this.sortBySortOrder);
        return result;
    };
    KissDeviceDetailTabsWidget.prototype.populateProductContents = function () {
        var listTemplate = "\n            <ul class=\"list\">\n                {LIST_ITEMS}\n            </ul>\n        ";
        var itemTemplate = "\n            <li>{ITEM}</li>\n        ";
        var productContentsList = listTemplate;
        var listItems = '';
        var features = this.GetAttributesById(126);
        for (var _i = 0, features_2 = features; _i < features_2.length; _i++) {
            var feature = features_2[_i];
            var element = itemTemplate;
            element = element.replace('{ITEM}', feature.value);
            listItems += element;
        }
        productContentsList = productContentsList.replace('{LIST_ITEMS}', listItems);
        jQuery('[data-productContents]').empty().append(productContentsList);
    };
    KissDeviceDetailTabsWidget.prototype.sortBySortOrder = function (a, b) {
        if (a.description.sortOrder < b.description.sortOrder) {
            return -1;
        }
        if (a.description.sortOrder > b.description.sortOrder) {
            return 1;
        }
        return 0;
    };
    KissDeviceDetailTabsWidget.prototype.populateTopFeatures = function () {
        var topFeatures = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-device-detail-tabs__top-feature'));
        var deviceImg = '<img src="https://eweb8.vfd2-testnet.de/' + Configurator.getProduct().getImages().large + '">';
        document.querySelector('.mod-ep-kiss-device-detail-tabs__top-features-image').innerHTML = deviceImg;
        if (this.GetAttributesById(20)) {
            var deviceDimensions = this.GetAttributesById(20)[0].value;
            document.querySelector('.mod-ep-kiss-device-detail-tabs__top-features-dimensions').innerHTML = deviceDimensions + ' mm';
        }
        for (var _i = 0, topFeatures_1 = topFeatures; _i < topFeatures_1.length; _i++) {
            var feature = topFeatures_1[_i];
            var featureLabel = feature.querySelector('.mod-ep-kiss-device-detail-tabs__top-feature-label');
            var attributeId = parseInt(feature.dataset.attributeid);
            var attribute = this.GetAttributesById(attributeId)[0];
            if (attribute) {
                var value = attribute.value;
                var label = '';
                if (attribute.description.label) {
                    label = attribute.description.label + ' ';
                }
                var unit = '';
                if (attribute.description.unit) {
                    unit = '&nbsp;' + attribute.description.unit;
                }
                featureLabel.innerHTML = label + value + unit;
            }
            else {
                featureLabel.innerHTML = 'Keine Angabe';
            }
        }
        this.addLoaded();
    };
    KissDeviceDetailTabsWidget.prototype.addLoaded = function () {
        jQuery('.mod-ep-kiss-device-detail-tabs').addClass('loaded');
    };
    KissDeviceDetailTabsWidget = __decorate([
        Widget({
            name: 'kiss-device-detail-tabs'
        })
    ], KissDeviceDetailTabsWidget);
    return KissDeviceDetailTabsWidget;
}());
export { KissDeviceDetailTabsWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-device-detail-tabs/kiss-device-detail-tabs.ts
// module id = null
// module chunks = 